export const ROLE_COURT_ADMIN = 'ROLE_COURT_ADMIN';
